import React from 'react';
import SearchCountryWidget from '../../../shared/components/SearchCountryWidget';

const DestinationCountry = ({
  value,
  depart,
  currency,
  dictionary,
  items = [],
  onChoose,
}) => {

  // костыль подсветки поля
  // const highlightCssClass = value != requestModel.country ? 'highlight' : '';
  const wasChange = value !== 4 ? true : false;
  return (
    <SearchCountryWidget
      type="select"
      label="Страна"
      title={`${dictionary[value].name}`}
      items={items}
      dictionary={dictionary}
      value={value}
      buttonDone={false}
      hasFilter={true}
      cssClass={`country`}
      width={280}
      depart={depart}
      currency={currency}
      isChanged={wasChange}
      onChoose={onChoose}
    />
  );
};

export default DestinationCountry;
